const s = "af.notification", t = class t extends CustomEvent {
  constructor(o) {
    super(s, { detail: o, bubbles: !0, composed: !0 });
  }
};
t.EVENT_NAME = s;
let e = t;
export {
  s as EVENT_NAME,
  e as default
};
//# sourceMappingURL=NotificationEvent.js.map
